import type { UpdateContactTrainingInfoRequestDto } from '@cobliteam/common-types';
import gql from 'graphql-tag';

import type { MutationUpdateContactTrainingArgs } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

class GraphQLCrmRequester {
  public updateContactTrainings = async (userTrainings: UpdateContactTrainingInfoRequestDto): Promise<any> => {
    const input = {
      finishedVideos: userTrainings.finishedVideos,
      startedVideos: userTrainings.startedVideos,
    };

    return graphQLRequester.mutate<{ updateContactTrainings: UpdateContactTrainingInfoRequestDto }, MutationUpdateContactTrainingArgs>({
      mutation: gql`
        mutation Mutation($input: UpdateContactTrainingInfoInput!) {
          updateContactTraining(input: $input)
        }
      `,
      variables: {
        input: input,
      },
    });
  };

  public getSchedulingHolidays = (): Promise<Array<Date>> => {
    return graphQLRequester
      .query<{ schedulingHolidays: Array<string> }>({
        query: gql`
          query Query {
            schedulingHolidays
          }
        `,
      })
      .then((graphQLResponse) =>
        graphQLResponse.schedulingHolidays.map((x) => {
          var dateArray = x.split('-');
          var year = dateArray[0];
          var month = Number.parseInt(dateArray[1], 10) - 1;
          var date = dateArray[2];
          // @ts-ignore
          return new Date(year, month, date);
        })
      );
  };
}

export default GraphQLCrmRequester;
